import React, { useCallback, useState, useEffect, useRef } from 'react';
import style from './MedicalDetails.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import TotalMedicalPaidDetailBox from '../../../../components/box/TotalMedicalPaidDetailBox';
import URL from '../../../../constants/url';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import { formatDateWithWeekday, formatTime24 } from '../../../../assets/js/comm';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

import Skeleton from '@mui/material/Skeleton';

const MedicalDetails = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [mediInfo, setMediInfo] = useState();
    const [clnicHistoryInfo,  setClnicHistoryInfo] = useState({});
    const [clnicExamRsltInfo, setClnicExamRsltInfo] = useState([]);
    const [clnicMedPrscInfo, setClnicMedPrscInfo] = useState([]);
    const [clnicDgnssList, setClnicDgnssList] = useState([]);
    const [isLoading, setIsLoading] = useState(false); // 상태 추가
    
    const { hsptlCd = "", hsptlNm = "", patntId = "", deptCd = "", clnicDt = ""} = location.state || {};

    const [open, setOpen] = useState(false);
        
    useEffect(() => {
        getClnicInfo();
    }, []);


    const getClnicInfo = useCallback(async () => {

        setIsLoading(true);

        const url = "/hsptl/retrieveHsptlClnicHistoryInfo";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
            hsptlCd : hsptlCd, 
            patntId : patntId,
            deptCd: deptCd,
            clnicDt : clnicDt
        }

        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
            , withCredentials: true
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {
            //console.log(res.data.resultCode)
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const mediInfo = res.data.result;
                
                setMediInfo({...mediInfo});
                setClnicHistoryInfo(mediInfo.clnicHistoryInfo);
                setClnicExamRsltInfo(mediInfo.clnicExamRsltInfo);
                setClnicMedPrscInfo(mediInfo.clnicMedPrscInfo);
                setClnicDgnssList(mediInfo.clnicDgnssList);

                console.log(">>>>>>>>> : " , mediInfo.clnicHistoryInfo)
                
            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })
        .finally(() => {
            setIsLoading(false);
        });

    }, [navigate]);




    function onDismiss() {
        setOpen(false);
    }
    
    return (
        <>
            <HeadSub title="진료 상세 " />

            <div id="sub-content" data-layout="white">     
                <div className='inner-wrap' data-pad="normal">
                    
                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>기본정보</h2>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}>
                                <ul>
                                    <li>
                                        <p>예약일시</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="120px" height={20} />
                                        ) : (
                                        <span>{clnicHistoryInfo ? formatDateWithWeekday(clnicHistoryInfo.clnicDt) : ''} {clnicHistoryInfo ? formatTime24(clnicHistoryInfo.clnicTm) : ''}</span>
                                        )}
                                    </li>
                                    <li>
                                        <p>진료구분</p>
                                        <span>외래</span>
                                    </li>
                                    <li>
                                        <p>병원</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="60px" height={20} />
                                        ) : (
                                        <span>{hsptlNm}병원</span>
                                        )}
                                    </li>
                                    <li>
                                        <p>진료과</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="60px" height={20} />
                                        ) : (
                                        <span>{clnicHistoryInfo ? clnicHistoryInfo.deptNm : ''}</span>
                                        )}
                                    </li>
                                    <li>
                                        <p>의료진</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="60px" height={20} />
                                        ) : (
                                        <span>{clnicHistoryInfo ? clnicHistoryInfo.doctrNm : ''}</span>
                                        )}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>총 진료비</h2>
                            <button className='btn' data-btn-type="fill-gray" data-btn-size='sm' onClick={() => setOpen(true)}>
                                <span>상세보기</span>
                            </button>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}>
                                <ul>
                                    <li>
                                        <p>수납금액</p>
                                        {isLoading ? (
                                            <Skeleton variant="text" width="60px" height={20} />
                                        ) : (
                                        <span>{Number(clnicHistoryInfo.pymtAmt).toLocaleString()}원</span>
                                        )}
                                    </li>
                                    <li>
                                        <p>상태</p>

                                        {isLoading ? (
                                            <Skeleton variant="text" width="60px" height={20} />
                                        ) : (
                                           clnicHistoryInfo.unpaidAmt !== 0 ? <span className={style["not-paid"]}>미수납</span> : <span className={style["paid"]}>수납완료</span>                                        
                                        )}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>


                    {/* <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>검사 내역</h2>
                            {
                                clnicExamRsltInfo.totalCount !== 0 &&
                                <button className='btn' data-btn-type="fill-gray" data-btn-size='sm' onClick={()=> navigate(URL.HOSPITAL_INSPECTIONDETAIL, {
                                    state: {
                                        hsptlCd: hsptlCd,
                                        patntId: patntId,
                                        deptCd: deptCd,
                                        testDt: clnicDt,
                                    }                                                                     
                                })}>
                                    <span>상세보기</span>
                                </button>
                            }
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}>
                                {
                                    clnicExamRsltInfo.totalCount === 0 ? 
                                    <>
                                        <p className={style["no-data"]}>검사 내역이 없습니다.</p>    
                                    </> :
                                    <>
                                        <ul>
                                            <li data-list-type="column">
                                                <p>총 {clnicExamRsltInfo.totalCount}건</p>
                                                <span>{clnicExamRsltInfo.prscrptnTestCtgrNm}</span>
                                            </li>
                                        </ul>                                        
                                    </>
                                }
                            </div>
                        </div>
                    </div> */}

                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>약물 처방 내역</h2>
                            {

                                clnicMedPrscInfo && clnicMedPrscInfo.totalCount !== 0 &&
                                <button className='btn' data-btn-type="fill-gray" data-btn-size='sm' onClick={()=> navigate(URL.HOSPITAL_PRESCRIPTIONDETAIL, {
                                    state: {
                                        hsptlCd: hsptlCd,
                                        patntId: patntId,
                                        deptCd: deptCd,
                                        treatYmd: clnicDt,
                                    }                                                                     
                                })}>
                                    <span>상세보기</span>
                                </button>
                            }
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}> 
                                {isLoading ? (
                                            <Skeleton variant="text" width="120px" height={24} />
                                        ) : (
                                    clnicMedPrscInfo?.totalCount === 0 ? 
                                    <>
                                        <p className={style["no-data"]}>처방 내역이 없습니다.</p>    
                                    </> :
                                    <>
                                        <ul>
                                            <li data-list-type="column">
                                                <p>총 {clnicMedPrscInfo?.totalCount}건</p>
                                                <span>{clnicMedPrscInfo?.prscrptnNm}</span>

                                            </li>
                                        </ul>                                        
                                    </>                               
                                )}

                            </div>
                        </div>
                    </div>

                    {/* <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>진단 내역</h2>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}>


                                {isLoading ? (
                                            <Skeleton variant="text" width="120px" height={24} />
                                        ) : (
                                        clnicDgnssList?.length > 0 ? 
                                        <ul>
                                            <li>
                                                <p>주진단</p>
                                            </li>
                                            <li>
                                                <ul>
                                                    {
                                                    clnicDgnssList.filter(item => item.mainDgnssFlag === 'Y').map((item)=>{
                                                        return(
                                                            <li>
                                                                <span>{item.dgnssCd}</span> <span style={{ marginLeft: '20px' }}>{item.dgnssEngNm}</span>
                                                            </li>
                                                        )
                                                    })  
                                                    }    
                                                </ul>                                            
                                            </li>
                                        </ul>
                                        :
                                            <p className={style["no-data"]}>진단 내역이 없습니다.</p>    
                                
                                )}
                            </div>
                        </div>
                    </div>  */}

 

                    <BottomSheet
                        scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                        expandOnContentDrag={false} // 내용 드래그로 확장 방지
                        open={open}
                        onDismiss={onDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={true} >
                            <TotalMedicalPaidDetailBox 
                                key={`${hsptlCd}_${patntId}_${clnicDt}`} // 고유값 지정
                                hsptlCd={hsptlCd} 
                                patntId={patntId} 
                                clnicDt={clnicDt} 
                                onClose={onDismiss}/>
                    </BottomSheet>

                </div>
            </div>
            
        </>
    );
};

export default MedicalDetails;
